import * as React from 'react';

interface LockIconProps {
  className?: string;
  color?: string;
}

const LockIcon = ({ className, color = 'currentColor' }: LockIconProps): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={className}>
      <g stroke={color} fill="none" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
        <path d="M5.25 9.75h13.5a1.5 1.5 0 011.5 1.5v10.5a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-10.5a1.5 1.5 0 011.5-1.5zm1.5 0V6a5.25 5.25 0 0110.5 0v3.75" />
        <path d="M12 14.25a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5z" />
      </g>
    </svg>
  );
};

export default LockIcon;
